import css from './emptySVGPlaceholder.module.css'

const EmptySVGPlaceholder = () => {
  return (
    <div className={css.wrapper}>
      <p className="text-heading-2 text-description">Виджет "SVG-Схема"</p>
      <p className="text-nm">Для конфигурации кликните правой кнопкой по настоящей области и нажмите "Редактировать"</p>
    </div>
  )
}

export default EmptySVGPlaceholder
